import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=c7c0d13e"
import script from "./realtime.vue?vue&type=script&lang=js"
export * from "./realtime.vue?vue&type=script&lang=js"
import style0 from "./realtime.vue?vue&type=style&index=0&id=c7c0d13e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports